import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'src/utils/axios';

const dataConfig = {
  headers: { 'Content-Type': 'application/json' }
};

export const getAutomationLogList = createAsyncThunk('/GetAutomationLogList', async (filters) => {
  const response = await axios.post('/GetAutomationLogList', filters, dataConfig);
  return response.data;
});

export const getAutomationLogSummary = createAsyncThunk('/GetAutomationLogSummary', async (filters) => {
  const response = await axios.post('/GetAutomationLogSummary', filters, dataConfig);
  return response.data;
});

export const simulateAutomationCase = createAsyncThunk('/SimulateAutomationCase', async (data) => {
  const response = await axios.post('/SimulateAutomationCase', data, dataConfig);
  return response.data;
});

export const getAutomationTypes = createAsyncThunk('/GetAutomationTypes', async () => {
  const response = await axios.get('/GetAutomationTypes', dataConfig);
  return response.data;
});

export const getAutomationDictionary = createAsyncThunk('/GetAutomationDictionary', async () => {
  const response = await axios.get('/GetAutomationDictionary', dataConfig);
  return response.data;
});

const automationLogSlice = createSlice({
  name: 'automationLog',
  initialState: {
    rows: [],
    totalCount: 0,
    summary: [],
    automationTypes: [],
    dictionary: [],
    loading: false,
    error: ''
  },
  reducers: {},
  extraReducers: {
    [getAutomationLogList.pending]: (state) => {
      state.loading = true;
    },
    [getAutomationLogList.rejected]: (state, action) => {
      state.error = action.error.message;
      state.loading = false;
    },
    [getAutomationLogList.fulfilled]: (state, action) => {
      state.rows = action.payload.Rows || [];
      state.totalCount = action.payload.TotalCount || 0;
      state.loading = false;
    },
    [getAutomationLogSummary.fulfilled]: (state, action) => {
      state.summary = action.payload || [];
    },
    [getAutomationTypes.fulfilled]: (state, action) => {
      state.automationTypes = action.payload || [];
    },
    [getAutomationDictionary.fulfilled]: (state, action) => {
      state.dictionary = action.payload || [];
    }
  }
});

export const automationLogActions = automationLogSlice.actions;
export default automationLogSlice;
